import { render } from "./Headline.vue?vue&type=template&id=7fc876c6"
import script from "./Headline.vue?vue&type=script&lang=js"
export * from "./Headline.vue?vue&type=script&lang=js"

import "./Headline.vue?vue&type=style&index=0&id=7fc876c6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__